/*
=============================================
Author      : <ยุทธภูมิ ตวันนา>
Create date : <๒๕/๐๗/๒๕๖๓>
Modify date : <๒๕/๐๗/๒๕๖๓>
Description : <>
=============================================
*/

'use strict';

import { Component, OnInit } from '@angular/core';

@Component({
    selector: '',
    template: '',
    styleUrls: []
})
export class PageEmptyComponent implements OnInit {
    constructor() {
    }

    ngOnInit(): void {
    }
}
